var xP = require('../xP')
  , $ = require('jquery');

module.exports = {
  name: 'datetime', base: 'date', prototype: {
    element_selector: 'input.datetime, .datetime input',

    _spliters: ['-', '-', ' ', ':', ''],

    init: function (params) {
      xP.controls.datetime.base.init.apply(this, arguments);

      var html = this._number_begin_html + ', min: 0, max: 23" value="'
        + (this._.values[3] !== undefined ? this._.values[3] : '')
        + '" size="2" maxlength="2" class="hours"/>'
        + '<span class="time_spliter"></span>'
        + this._number_begin_html + ', min: 0, max: 59" value="'
        + (this._.values[4] !== undefined ? this._.values[4] : '')
        + '" size="2" maxlength="2" class="minutes"/>';

      var $time = $(html).insertBefore(this.$element), that = this;

      this._.pseudo.append(xP($time).each(function () {
        this.change(function () {
          that._change_pseudo();
        });
      }));

      this._.$pseudo.add($time);
    }

  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/datetime.js
 ** module id = 14
 ** module chunks = 0
 **/